<template>
  <div>
    <div class="honor">
      <div class="honor-header">
        <div class="cn-title">荣誉资质</div>
        <div class="divider"></div>
        <div class="en-title">
          <span>HONOR</span>
          <span>AND QUALIFICATION</span>
        </div>
      </div>
      <div class="honor-list">
        <div
          v-loading="loading"
          class="right"
        >
          <div
            v-if="honorList.length"
            class="honor-grid"
          >
            <div
              v-for="item in honorList"
              :key="item.id"
              class="honor-card"
            >
              <div class="image-wrap">
                <el-image
                  fit="contain"
                  :src="getImageUrl(item.imgPath)"
                  :preview-src-list="[getImageUrl(item.imgPath)]"
                  class="honor-image"
                >
                  <div
                    slot="error"
                    class="image-slot"
                  >
                    暂无图片
                  </div>
                </el-image>
              </div>
              <div
                v-if="item.title"
                class="title"
                :title="item.title"
              >
                {{ item.title }}
              </div>
            </div>
          </div>
          <div
            v-else
            class="empty-wrap"
          >
            <el-empty description="暂无荣誉资质" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { doGet } from "@/utils/http";

export default {
  name: "Honor",
  data() {
    return {
      loading: false,
      honorList: [],
      ossBaseUrl: "https://jd-data.oss-cn-shanghai.aliyuncs.com/",
    };
  },
  created() {
    this.getHonorList();
  },
  methods: {
    async getHonorList() {
      this.loading = true;
      try {
        const res = await doGet("/home/honor-qualification/list");
        this.honorList = Array.isArray(res && res.data) ? res.data : [];
      } catch (error) {
        console.error("获取荣誉资质列表失败", error);
        this.honorList = [];
      } finally {
        this.loading = false;
      }
    },
    getImageUrl(imgPath) {
      if (!imgPath) {
        return "";
      }
      if (/^https?:\/\//i.test(imgPath)) {
        return imgPath;
      }
      return `${this.ossBaseUrl}${imgPath}`;
    },
  },
};
</script>

<style scoped lang="less">
.honor {
  width: 1200px;
  margin: 48px auto 120px auto;

  .honor-header {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 52px;

    .cn-title {
      font-size: 38px;
      font-weight: 700;
      line-height: 1;
      color: #1253B0;
      letter-spacing: 2px;
    }

    .divider {
      width: 3px;
      height: 36px;
      background: #1253B0;
      margin: 0 12px;
    }

    .en-title {
      display: flex;
      flex-direction: column;
      font-size: 16px;
      font-weight: 700;
      line-height: 1.1;
      color: #1253B0;
    }
  }

  .honor-list {
    .right {
      min-height: 544px;
      background: transparent;
      padding: 0;
      box-sizing: border-box;

      .honor-grid {
        display: grid;
        grid-template-columns: repeat(4, minmax(0, 1fr));
        column-gap: 34px;
        row-gap: 42px;
      }

      .honor-card {
        min-width: 0;
      }

      .image-wrap {
        height: 308px;
        background: #FFFFFF;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 10px;
        box-sizing: border-box;
      }

      .honor-image {
        width: 100%;
        height: 100%;
      }

      .image-slot {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #999999;
        background: #F5F7FA;
      }

      .title {
        margin-top: 12px;
        min-height: 44px;
        line-height: 22px;
        font-size: 16px;
        color: #444444;
        text-align: center;
        word-break: break-all;
      }

      .empty-wrap {
        min-height: 520px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
